import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import getSalients from "../../services/getSalients";
import API_BASE_URL from '../../config.js';
import { useSearch } from "../../context/SearchContext";
import getCities from "../../services/getCities";

const Salient = () => {
    const { city, setCity, setTags, handleSearch } = useSearch();
    const [salients, setSalients] = useState([]);
    const [selected, setSelected] = useState(null);
    const [card, setCard] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const destinosRef = useRef(null);
    const [resultCities, setResultCities] = useState({});

    const BASE_URL = API_BASE_URL.slice(0, -4);
    const navigate = useNavigate();

    const handleClick = async (selected) => {

        setCity(selected)
        try {
            const filterTags = resultCities?.cities[selected] || []
            setTags(filterTags)
            // handleSearch();
            navigate(`/listings/?city=${encodeURIComponent(selected)}`);
        } catch (error) {
        }

    };

    useEffect(() => {
        const fetchSalients = async () => {
            const responseSalients = await getSalients();
            setSalients(responseSalients);
        };
        const fetchCities = async () => {
            const responseCities = await getCities();
            setResultCities(responseCities)
        };
        fetchCities();
        fetchSalients();
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className="bg-white p-6 mx-auto font-poppins md:w-[80%]">
            <div ref={destinosRef} className="mb-4">
                <h2 id="destacados" className="text-xl font-bold text-primaryP">Conoce nuestros apartamentos en cada ciudad</h2>
                {/* <p className="text-[#AB9E8B] text-sm">Favoritos entre nuestros huéspedes</p> */}
            </div>

            <div className="flex flex-wrap gap-4 justify-center items-center flex-row">
                {salients.map((salient, index) => (
                    <div
                        key={index}
                        className={`relative md:w-56 md:h-56 rounded-lg overflow-hidden cursor-pointer transition-all ${selected === index ? "border-4 border-primaryP" : "border-none"
                            }`}
                        onClick={() => handleClick(salient.city)}
                    >
                        <img
                            src={`${BASE_URL}${isMobile ? salient.imagenMovil : salient.imagenDesktop}`}
                            alt={salient.city}
                            className="w-full h-full object-cover"
                        />

                        <div className="absolute inset-0 flex items-center justify-center bg-transparent bg-opacity-40">
                            <span className="text-white text-lg font-bold">{salient.city}</span>
                        </div>
                    </div>
                ))}

            </div>
        </div>
    );
};

export default Salient;
